module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/event-2-dd0c0fdabdd374dafaa46b84efc713f3.jpg";